<template>
  <div class="alert p-2 rounded mb-3 py-2" :class="studentReferralBgClass">
    <div class="d-flex align-items-center">
      <em
        class="fa fa-bell-exclamation pl-2"
        :class="[studentReferralTextColor, studentReferralIcon]"
      />
      <div
        class="font-14 font-weight-normal ml-3"
        :class="studentReferralTextColor"
      >
        {{ therapyReferralMessage }}
      </div>
    </div>
  </div>
</template>

<script>
import admissionStatus from '@/utils/constants/admissionStatus.js';
export default {
  name: 'RequestStudentAdmissionMessage',
  props: {
    studentAdmissionInfo: {
      type: Object,
      default: () => {},
    },
    serviceInfo: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    hasReferredAdmittedOrRelatedActiveService() {
      return [
        admissionStatus.Admitido,
        admissionStatus.ServicioRelacionadoActivo,
      ].includes(this.studentAdmissionInfo?.admissionStatusId);
    },
    hasReferredLinkedOrAssigned() {
      return [admissionStatus.Vinculado, admissionStatus.Asignado].includes(
        this.studentAdmissionInfo?.admissionStatusId
      );
    },
    therapyReferralMessage() {
      if (this.hasReferredAdmittedOrRelatedActiveService)
        return `El servicio ${this.serviceInfo.serviceDiscipline} cuenta con un referido ${this.studentAdmissionInfo?.referralNumber} en estatus ${this.studentAdmissionInfo?.admissionStatus} en SAEE.`;

      if (this.hasReferredLinkedOrAssigned)
        return `El servicio ${this.serviceInfo.serviceDiscipline} cuenta con un referido ${this.studentAdmissionInfo?.referralNumber} en SAEE.`;

      return '';
    },
    studentReferralBgClass() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'bg-secondary-19'
        : 'bg-secondary-41';
    },
    studentReferralTextColor() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'color-secondary-20'
        : 'color-secondary-40';
    },
    studentReferralIcon() {
      return this.hasReferredAdmittedOrRelatedActiveService
        ? 'fas fa-exclamation-circle'
        : 'fa fa-bell-exclamation';
    },
  },
};
</script>
